<section class="video jarallax">
  <div class="space"></div>

  <app-video-card></app-video-card>


  <div class="space"></div>
</section>
